import { useEffect } from 'react';

import PropTypes from 'prop-types';
import { BsExclamationTriangleFill } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import { useErrorStore } from '#lib/stores/errorStore';

/**
 * Inline error state for a failed query: fires the global error toast once on mount and offers a
 * retry, so a fetch failure never masquerades as an empty list or all-zero stats.
 */
export default function PostMailingQueryError({ error, title, onRetry }) {
	const showError = useErrorStore((s) => s.showError);

	useEffect(() => {
		showError({ error, title });
	}, [error, title, showError]);

	return (
		<div className="flex flex-col items-center justify-center py-10 text-center">
			<BsExclamationTriangleFill className="mb-2 h-6 w-6 text-warning-500" />
			<p className="mb-3 text-sm text-text">{title}</p>
			<Button variant="outline" size="sm" onClick={onRetry}>
				Erneut laden
			</Button>
		</div>
	);
}

PostMailingQueryError.propTypes = {
	error: PropTypes.object,
	title: PropTypes.string.isRequired,
	onRetry: PropTypes.func.isRequired,
};
